<template>
  <svg class="logotipo-sitio" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 384 128" enableBackground="new 0 0 384 128">
    <g>
      <g>
        <path class="st0" d="M83.2,96c0.3,0.7,0.4,1.2,0.4,1.6c0,0.6-0.2,1.2-0.7,1.6c-0.5,0.5-1,0.7-1.6,0.7H68c-1.2,0-2.1-0.3-2.8-0.8
                    c-0.7-0.5-1.1-1.1-1.3-1.8l-3-8.8h-28l-3,8.8c-0.2,0.7-0.7,1.3-1.3,1.8c-0.7,0.5-1.6,0.8-2.8,0.8H12.5c-0.6,0-1.2-0.2-1.6-0.7
                    c-0.5-0.5-0.7-1-0.7-1.6c0-0.4,0.1-0.9,0.4-1.6l23-66.5c0.4-1,0.9-1.8,1.7-2.5s1.8-1,3.1-1h17.1c1.3,0,2.3,0.3,3.1,1
                    s1.3,1.5,1.7,2.5L83.2,96z M55.4,72.1l-8.5-25.3l-8.5,25.3H55.4z" />
        <path class="st0" d="M109.9,117.1c0,0.8-0.3,1.4-0.8,2c-0.6,0.6-1.2,0.8-2,0.8H93.7c-0.8,0-1.4-0.3-2-0.8c-0.6-0.6-0.8-1.2-0.8-2
                    V47.9c0-0.8,0.3-1.4,0.8-2c0.6-0.6,1.2-0.8,2-0.8h12.8c0.8,0,1.4,0.3,2,0.8c0.6,0.6,0.8,1.2,0.8,2v2.4c1.1-1.3,2.2-2.4,3.2-3.3
                    c1-0.8,2.5-1.6,4.3-2.2c1.9-0.6,4.2-0.9,7.1-0.9c6.7,0,12.2,2,16.6,6.1s6.7,10.1,7,18c0.1,0.7,0.1,2.1,0.1,4.2
                    c0,2.2,0,3.6-0.1,4.3c-0.3,7.9-2.6,14-7,18.1s-9.9,6.2-16.7,6.2c-3.7,0-6.6-0.6-8.9-1.9s-4-2.7-5.3-4.4v22.6H109.9z M126.2,62.8
                    c-1.5-1.7-3.8-2.5-6.9-2.5c-2.9,0-5.1,0.8-6.6,2.4s-2.4,3.6-2.8,6c-0.1,1.4-0.2,2.6-0.2,3.7s0.1,2.3,0.2,3.7
                    c0.3,2.3,1.2,4.3,2.7,6s3.8,2.5,6.6,2.5c3.1,0,5.4-0.8,6.9-2.5s2.4-3.9,2.6-6.6c0.1-1.4,0.2-2.4,0.2-3s-0.1-1.5-0.2-3
                    C128.5,66.7,127.7,64.5,126.2,62.8z" />
        <path class="st0"
          d="M243,99c-0.6,0.6-1.2,0.8-2,0.8h-13.3c-0.8,0-1.4-0.3-2-0.8c-0.6-0.6-0.8-1.2-0.8-2V27.8c0-0.8,0.3-1.4,0.8-2
                    c0.6-0.6,1.2-0.8,2-0.8H241c0.8,0,1.4,0.3,2,0.8c0.6,0.6,0.8,1.2,0.8,2V97C243.9,97.8,243.6,98.5,243,99z" />
        <path class="st0" d="M256.4,45.8c0.6-0.6,1.2-0.8,2-0.8h13.3c0.8,0,1.4,0.3,2,0.8c0.6,0.6,0.8,1.2,0.8,2v26.7
                    c0,3.2,0.7,5.6,2.1,7.4s3.6,2.6,6.5,2.6c5.7,0,8.5-3.3,8.5-10V47.9c0-0.8,0.3-1.4,0.8-2c0.6-0.6,1.2-0.8,2-0.8h13.3
                    c0.8,0,1.4,0.3,2,0.8c0.6,0.6,0.8,1.2,0.8,2V97c0,0.8-0.3,1.4-0.8,2c-0.6,0.6-1.2,0.8-2,0.8h-12.2c-0.8,0-1.4-0.3-2-0.8
                    c-0.6-0.6-0.8-1.2-0.8-2v-2.4c-1.5,1.8-3.4,3.3-5.6,4.5c-2.3,1.2-5.4,1.8-9.2,1.8c-7,0-12.5-2-16.5-6c-3.9-4-5.9-10-5.9-18v-29
                    C255.6,47.1,255.9,46.4,256.4,45.8z" />
        <path class="st0" d="M325.4,72.5c-2.9-3-4.3-6.8-4.3-11.6c0-3.2,1-6,3.1-8.6s5-4.6,8.8-6.1s8-2.3,12.8-2.3c4.7,0,9,0.7,12.8,2.2
                c3.8,1.4,6.9,3.3,9.1,5.5c2.3,2.3,3.5,4.6,3.7,7.1c0.1,0.8-0.2,1.4-0.8,2c-0.6,0.6-1.3,0.8-2.1,0.8H356c-0.8,0-1.7-0.4-2.7-1.2
                c-0.9-0.7-1.9-1.2-3-1.6c-1.1-0.4-2.6-0.6-4.5-0.6c-1.7,0-3.1,0.2-4.1,0.7c-1.1,0.5-1.6,1.2-1.6,2.2c0,0.8,0.2,1.5,0.6,1.9
                s1.1,0.7,2.1,0.9c1,0.2,2.8,0.5,5.3,0.8l6.5,1.1c6.1,1,10.7,3.1,13.8,6.3c3.1,3.2,4.6,7,4.6,11.4c0,3.2-1.1,6.1-3.2,8.7
                s-5.2,4.7-9.3,6.3c-4,1.5-8.8,2.3-14.3,2.3c-5.3,0-9.9-0.8-13.8-2.3s-6.9-3.4-9-5.8c-2.1-2.3-3.2-4.7-3.4-7.1
                c-0.1-0.8,0.2-1.4,0.8-2c0.6-0.6,1.3-0.8,2.1-0.8H336c0.5,0,0.9,0.1,1.2,0.3c0.3,0.2,0.7,0.5,1.1,0.9c0.8,0.8,1.8,1.4,2.8,1.8
                c1.1,0.5,2.7,0.7,5.1,0.7c2.2,0,4-0.3,5.5-0.9s2.3-1.4,2.3-2.4c0-1.1-0.5-1.9-1.6-2.3s-3.4-0.9-7-1.4l-7.6-1.3
                C332.4,77.5,328.3,75.5,325.4,72.5z" />
      </g>
    </g>
    <g class="circulo-marca">
      <path class="st1" d="M165.3,71.2c0-10.6,8.6-19.1,19.1-19.1s19.1,8.6,19.1,19.1" />
      <path class="st1" d="M203.5,75.8c0,10.6-8.6,19.1-19.1,19.1s-19.1-8.6-19.1-19.1" />
    </g>
  </svg>
</template>

<style lang="scss">
  .logotipo-sitio {
    width: 100px;
    margin: auto;

    .st0 {
      fill: var(--text-color);
    }

    .st1 {
      fill: none;
      stroke: var(--color-primario);
      stroke-width: 17.2795;
      stroke-miterlimit: 10;
    }

    .circulo-marca {
      transition: 0.7s ease-in-out;
      transform-origin: center;
    }

    .circulo-marca.girar {
      transform: rotate(360deg);
    }
  }
</style>
